/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetLocationTaxonomyResponseDto } from '../models';
/**
 * LocationTaxonomyRestApi - axios parameter creator
 */
export const LocationTaxonomyRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get location taxonomy tree (countries -> regions -> starter cities)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationTaxonomy: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/locations/taxonomy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationTaxonomyRestApi - functional programming interface
 */
export const LocationTaxonomyRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationTaxonomyRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get location taxonomy tree (countries -> regions -> starter cities)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationTaxonomy(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLocationTaxonomyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationTaxonomy(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationTaxonomyRestApi.getLocationTaxonomy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LocationTaxonomyRestApi - factory interface
 */
export const LocationTaxonomyRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationTaxonomyRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Get location taxonomy tree (countries -> regions -> starter cities)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationTaxonomy(options?: RawAxiosRequestConfig): AxiosPromise<GetLocationTaxonomyResponseDto> {
            return localVarFp.getLocationTaxonomy(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationTaxonomyRestApi - interface
 */
export interface LocationTaxonomyRestApiInterface {
    /**
     * 
     * @summary Get location taxonomy tree (countries -> regions -> starter cities)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLocationTaxonomy(options?: RawAxiosRequestConfig): AxiosPromise<GetLocationTaxonomyResponseDto>;

}

/**
 * LocationTaxonomyRestApi - object-oriented interface
 */
export class LocationTaxonomyRestApi extends BaseAPI implements LocationTaxonomyRestApiInterface {
    /**
     * 
     * @summary Get location taxonomy tree (countries -> regions -> starter cities)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLocationTaxonomy(options?: RawAxiosRequestConfig) {
        return LocationTaxonomyRestApiFp(this.configuration).getLocationTaxonomy(options).then((request) => request(this.axios, this.basePath));
    }
}

